import { withUiVersion } from 'hoc/withUiVersion';
import NavMenuPrev from './NavMenu';
import { NavMenu as NavMenuNext } from 'components/v2/organisms/NavMenu/NavMenu';

const NavMenu = withUiVersion(NavMenuPrev, NavMenuNext);

export { NavMenu };
